// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__35YEN","footer":"ModalCreateQualiphyProcedure_footer__1GrcS","additionData":"ModalCreateQualiphyProcedure_additionData__1SWzI"};